import type { ContractDetail } from './api'

interface ContractTermsSummaryProps {
  readonly contract: ContractDetail
  readonly testIdPrefix?: string
}

/** Lesedarstellung der serverseitig bestimmten aktuellen Vertragskonditionen.
 * Sie wird vor Geld wiederverwendet, ohne Beträge oder Status im Client zu
 * berechnen. */
export function ContractTermsSummary({ contract, testIdPrefix = 'contract-read' }: ContractTermsSummaryProps) {
  return (
    <section data-testid={`${testIdPrefix}-terms`}>
      <h3 className="text-label text-muted">Konditionen</h3>
      <dl className="text-body text-text mt-1 grid gap-3 sm:grid-cols-2">
        <Term label="Kaltmiete" value={contract.base_rent_display} testId={`${testIdPrefix}-base-rent`} numeric />
        <Term label="Nebenkostenvorauszahlung" value={contract.operating_cost_advance_display} testId={`${testIdPrefix}-operating-cost-advance`} numeric />
        <Term label="Fälligkeitstag" value={contract.payment_due_day} testId={`${testIdPrefix}-payment-due-day`} />
        <Term label="Kaution" value={contract.deposit_display} testId={`${testIdPrefix}-deposit`} numeric />
      </dl>
    </section>
  )
}

function Term({ label, value, testId, numeric = false }: { readonly label: string; readonly value: string | number | null; readonly testId: string; readonly numeric?: boolean }) {
  return <div><dt className="text-label text-muted">{label}</dt><dd data-testid={testId} data-numeric={numeric || undefined} className={`text-body text-text ${numeric ? 'text-right' : ''}`}>{value ?? '—'}</dd></div>
}
